import { useEffect, useState, useRef } from 'react';
import { queryRescueOrderList } from '../js/request';
import { ORDER_STATE_INTERVAL_TIME } from '../js/constant';

interface IOrderItemType {
  rescueStatus: string;
  plateNo: string;
  driverPhone: string;
  driverName: string;
  orderNumber: string
}

export default function useQueryOrderListHook() {
  const [orderList, setOrderList] = useState<IOrderItemType[]>([]);
  const [isPending, setIsPending] = useState(true);
  const intervalTimer = useRef(0);

  const loadOrderList = () => {
    setIsPending(true);
    queryRescueOrderList()
      .then(ret => {
        const { data } = ret;
        setIsPending(false);
        setOrderList(data);
      })
      .catch(e => {
        setIsPending(false);
      })
  }

  // 轮询更新数据
  useEffect(() => {
    intervalTimer.current = window.setInterval(() => {
      loadOrderList()
    }, ORDER_STATE_INTERVAL_TIME * 1000);
    return () => {
      if (intervalTimer.current) {
        clearInterval(intervalTimer.current);
      }
    }
  }, [])

  useEffect(() => {
    loadOrderList();
  }, [])

  return {
    isPending,
    orderList
  };
}